/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The ConversationscreateGroupSmsConversation model module.
 * @module model/ConversationscreateGroupSmsConversation
 * @version v0.3
 */
export default class ConversationscreateGroupSmsConversation {
  /**
   * Constructs a new <code>ConversationscreateGroupSmsConversation</code>.
   * @alias module:model/ConversationscreateGroupSmsConversation
   * @class
   * @param userIds {Array.<String>} 
   */
  constructor(userIds) {
    this.userIds = userIds;
  }

  /**
   * Constructs a <code>ConversationscreateGroupSmsConversation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ConversationscreateGroupSmsConversation} obj Optional instance to populate.
   * @return {module:model/ConversationscreateGroupSmsConversation} The populated <code>ConversationscreateGroupSmsConversation</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ConversationscreateGroupSmsConversation();
      if (data.hasOwnProperty('user_ids'))
        obj.userIds = ApiClient.convertToType(data['user_ids'], ['String']);
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} userIds
 */
ConversationscreateGroupSmsConversation.prototype.userIds = undefined;

/**
 * Conversation name
 * @member {String} name
 */
ConversationscreateGroupSmsConversation.prototype.name = undefined;

